import { ORDER_STATUS_LABELS_RU } from '@crm/shared'
import type { OrderDetailDto } from '@crm/shared'
import { formatDateTime } from '../orderFormat'

/**
 * История заказа: переходы статусов и (с 29.09.2026) правки состава — запись
 * «из статуса в тот же статус» с пояснением («Изменена позиция …», «Убраны
 * позиции …», «Добавлена позиция …»).
 */
export function OrderHistorySection({ order }: { order: OrderDetailDto }) {
  return (
    <section className="rounded-xl border border-gray-200 bg-white p-4">
      <h2 className="mb-3 text-base font-semibold">История заказа</h2>
      {order.statusHistory.length === 0 ? (
        <p className="text-sm text-gray-500">Истории нет.</p>
      ) : (
        <ol className="space-y-2 text-sm">
          {order.statusHistory.map((h) => (
            <li key={h.id} className="flex flex-wrap items-baseline gap-x-2">
              <span className="text-gray-500">{formatDateTime(h.createdAt)}</span>
              <span className="font-medium">
                {h.fromStatus === h.toStatus
                  ? '✎ Изменение заказа'
                  : `${h.fromStatus ? `${ORDER_STATUS_LABELS_RU[h.fromStatus]} → ` : ''}${ORDER_STATUS_LABELS_RU[h.toStatus]}`}
              </span>
              <span className="text-gray-500">· {h.actorName ?? 'система'}</span>
              {h.note && <span className="text-gray-600">— {h.note}</span>}
            </li>
          ))}
        </ol>
      )}
    </section>
  )
}
